import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import fileSaver from 'file-saver';
import DropZone from 'react-dropzone';
import _ from 'lodash';
// import Select from 'react-select';
import Select from 'react-select/async';
import { DatePicker, FileCard, BankCard, DatetimePicker } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import NetworkEmptyState from '../../../commons/networkemptystate';
import SwichButton from '../../../commons/SwitchButton';
import Loader from '../../../commons/loader';
import Services from './services';
import Lib from '../../../commons/lib';
import Cleave from 'cleave.js';
import RFForm, { FormContext } from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import SlaveAvInput from '../../../commons/SlaveAvInput';
import NumberFormatter from '../../../commons/NumberFormatter';
import SelectField from '../../../components/Form/SelectField';
import moment from 'moment';
import TimeFormatter from '../../../commons/TimeFormatter';

class CegadatForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cegadatId: '',
      cegadatValtozas: false,
      modositas: false,
      // FORM VALUES
      formTitle: '-',
      formTipus: '',
      formTeljesnev: '',
      formSzekhely: '',
      formRovidnev: '',
      formCegforma: '',
      formAdoszam: '',
      formKozossegiadoszam: '',
      formCegjegyzekszam: '',
      formKezdete: null,
      formVege: null,
      formBejegyzesdatum: null,
      formTelefon: '',
      formMobil: '',
      formFax: '',
      formHonlap: '',
      formEmail: '',
      formBankszamlaszam: [],
      formOrszag: '',
      formIranyitoszam: '',
      formIranyitoszamId: '',
      formTelepules: '',
      formTelepulesId: '',
      formKereses: '',
      formKozterulet: '',
      formKozteruletjelleg: '',
      formHazszam: '',
      formLepcsohaz: '',
      formEpulet: '',
      formEmelet: '',
      formAjto: '',
      formPostafiok: '',
      formKapcsolattartonev: '',
      formKapcsolattartotelefon: '',
      formKapcsolattartoemail: '',
      formObjectParam: [],
      formModalPenzintezet: '',
      formModalBankszamlaszam: '',
      formModalIbanszam: '',
      formIranyitoszamNev: '',
      formTelepulesNev: '',
      // -
      formMegjegyzes: '',
      formMunkalapType: '',
      formMunkalapId: '',
      formCegadat: '',
      formCegadatId: '',
      formPartner: '',
      formLeiras: '',
      formSpecialisID: '',
      formSpecialisHely: '',
      // ['LOAD', 'DATA', 'NETW']
      formKeszletLoadingStatus: 'LOAD',
      // FORM SECTIONS
      vizsgalatEredmenyData: null,
      cikkkezeles: false,
      autoveglegezeskezeles: false,
      leiraskezeles: false,
      osszegkezeles: false,
      workflowkezeles: false,
      // MODAL UTILS
      modalBankadatTitle: '-',
      modalBankadatButtonText: '-',
      // ['FEL', 'MOD']
      formBankadatType : 'FEL',
      modalBankadat: false,
      cimSwitchActive: true,
      // FORM UTILS
      // ['SEARCH', 'SELECT', 'TEXT']
      formIranyitoszamType: 'SEARCH',
      // ['SEARCH', 'SELECT', 'TEXT']
      formTelepulesType: 'SEARCH',
      files: [],
      bankszamlaszamok: [],
      cegadatTipusOptions: [],
      cegadatFormaOptions: [],
      cegadatSzekhelyOptions: [],
      lek: null,
      formCegadatValues: {
        tipus: {
          nev: null
        },
        nev: null,
        cim: null,
        telefon: null,
        email: null,
        adoszam: null,
      },
      submitButtonLoading: false,
      bankButtonLoading: false,
      // STATUS UTILS
      // ['LOAD', 'DATA', 'NETW']
      formCardStatus: 'LOAD',
    };
    this.selected = false;
  }

  componentDidMount() {
    if (this.props.type === 'MOD') {
      let params = new URL(window.location.href).searchParams;
      let id = params.get('id');
      this.setState({
        formTitle: 'Cégadat módosítás',
        cegadatId: id,
        modositas: true,
        lek: this.props && this.props.location && this.props.location.state && this.props.location.state.lek,
        cegadatValtozas: params.get('cegadatvaltozas') == 'true'
      }, () => {
        this.getCegadatEnum();
        this.getCegadat(id);
      });
    }
    if (this.props.type === 'FEL') {
      this.setState({
        cegadatValtozas: true,
        formTitle: 'Cégadat felvitel',
        formCardStatus: 'DATA',
        lek: this.props && this.props.location && this.props.location.state && this.props.location.state.lek
      });
      this.getCegadatEnum();
      this.getAktivSzekhelyList();
      // this.getTipusList();
      // this.getMegjegyzes();
    }
    // this.listActiveTelephely();
  }

  toggleBankadat = () => {
    this.setState(prevState => ({ modalBankadat: !prevState.modalBankadat }));
  }

  toggleCimSwitch = (trueFalse) => {
    if (trueFalse !== this.state.cimSwitchActive) {
      this.setState(prevState => ({
        cimSwitchActive: !prevState.cimSwitchActive,
        formPostafiok: '',
        formKozterulet: '',
        formKozteruletjelleg: '',
        formHazszam: '',
        formLepcsohaz: '',
        formEpulet: '',
        formEmelet: '',
        formAjto: ''
      }));
    }
  }

  handleNewBankadatClick = () => {
    this.setState({
      formModalPenzintezet: '',
      formModalBankszamlaszam: '',
      formModalIbanszam: '',
      formBankadatType: 'FEL',
      modalBankadatTitle: 'Új banktétel hozzáadása',
      modalBankadatButtonText: 'Hozzáadás',
      currentBankId: null
    }, () => {
      this.toggleBankadat();
    });
  }

  handleBankadatChange = (idx) => {
    this.setState(prevState => ({
      formModalPenzintezet: this.nullToString(prevState.formBankszamlaszam[idx].penzintezet),
      formModalBankszamlaszam: this.nullToString(prevState.formBankszamlaszam[idx].bankszamlaszam),
      formModalIbanszam: this.nullToString(prevState.formBankszamlaszam[idx].ibanszam),
      modalBankadatTitle: 'Banktétel módosítása',
      currentBankId: idx,
      formBankadatType: 'MOD',
      modalBankadatButtonText: 'Módosítás'
    }), () => {
      this.toggleBankadat();
    });
  }

  handleBankadatDelete = (index) => {
    this.setState(prevState => ({
      formBankszamlaszam: [...prevState.formBankszamlaszam.slice(0, index), ...prevState.formBankszamlaszam.slice(index + 1)]
    }));
  }

  addBankadat = (event, bankObj) => {
    if (this.state.formBankszamlaszam.some((bankszamla, idx) => (this.state.currentBankId === null || this.state.currentBankId != idx) && bankszamla.bankszamlaszam === bankObj.formModalBankszamlaszam)){
      this.props.globals.addError("Ez a bankszámlaszám már meg lett adva a cégadathoz!");
      return;
    }

    this.setState({ bankButtonLoading: true });

    let checkObj = {
      bankszamlaszam: bankObj.formModalBankszamlaszam,
      ibanszam: bankObj.formModalIbanszam,
      penzintezet: this.emptyOrNull(bankObj.formModalPenzintezet)
    };

    Services.checkBank(checkObj, (err) => {
      if (!err) {
        if (this.state.formBankadatType === 'FEL') {
          this.setState(prevState => ({
            bankButtonLoading: false,
            formBankszamlaszam: [...prevState.formBankszamlaszam, {
              bankszamlaszam: bankObj.formModalBankszamlaszam,
              ibanszam: bankObj.formModalIbanszam,
              penzintezet: this.emptyOrNull(bankObj.formModalPenzintezet)
            }]
          }));
        } else {
          let prevBankszamlaszam = JSON.parse(JSON.stringify(this.state.formBankszamlaszam));
          prevBankszamlaszam[this.state.currentBankId] = {
            bankszamlaszam: bankObj.formModalBankszamlaszam,
            ibanszam: bankObj.formModalIbanszam,
            penzintezet: this.emptyOrNull(bankObj.formModalPenzintezet)
          };
          this.setState({
            bankButtonLoading: false,
            formBankszamlaszam: prevBankszamlaszam
          });
        }
        this.toggleBankadat();
      } else {
        this.setState({ bankButtonLoading: false });
      }
    });
  }

  getCegadatEnum = () => {
    Services.getCegadatEnum((err, res) => {
      if (!err) {
        let cegadatTipusOptions = [];
        res[0][0].forEach((item) => {
          cegadatTipusOptions.push(
            <option
              value={item.name}
              key={item.name}
            >
              {item.caption}
            </option>
          );
        });
        let cegadatFormaOptions = [];
        res[0][1].forEach((item) => {
          cegadatFormaOptions.push(
            <option
              value={item.name}
              key={item.name}
            >
              {item.caption}
            </option>
          );
        });
        this.setState({
          cegadatTipusOptions: cegadatTipusOptions,
          cegadatFormaOptions: cegadatFormaOptions
        }, () => {
          // this.getSpecialis(res[0].specialis);
        });
      }
    });
  }

  getAktivSzekhelyList = (ids) => {
    Services.getAktivSzekhelyList(ids, (err, res) => {
      if (!err) {
        let szekhelyOptions = [];
        res[0].forEach((item) => {
          szekhelyOptions.push(
            <option
              value={item.id}
              key={item.id}
            >
              {item.nev}
            </option>
          );
        });
        this.setState({
          cegadatSzekhelyOptions: szekhelyOptions,
        }, () => {
          // this.getSpecialis(res[0].specialis);
        });
      }
    });
  }

  getCegadat = (id) => {
    Services.getCegadat(id, (err, res) => {
      if (!err) {
        let adoszam = this.emptyOrNull(res[0].adoszam);
        adoszam = adoszam ? adoszam.slice(0, 8) + '-' + adoszam.slice(8, 9) + '-' + adoszam.slice(9, 11) : this.nullToString(adoszam);
        this.setState({
          formCardStatus: 'DATA',
          formTipus: this.nullToString(res[0].tipus && res[0].tipus.name),
          formTeljesnev: this.nullToString(res[0].teljesnev),
          formSzekhely: this.nullToString(res[0].szekhelyentity && res[0].szekhelyentity.id),
          formRovidnev: this.nullToString(res[0].rovidnev),
          formAdoszam: adoszam,
          formKozossegiadoszam: this.nullToString(res[0].kozossegiadoszam),
          formCegforma: this.nullToString(res[0].cegforma && res[0].cegforma.name),
          formBejegyzesdatum: res[0].bejegyzesdatum,
          formCegjegyzekszam: this.nullToString(res[0].cegjegyzekszam),
          formKezdete: res[0].kezdete && new Date(res[0].kezdete),
          formVege: res[0].vege && new Date(res[0].vege),
          formTelefon: this.nullToString(res[0].telefon),
          formMobil: this.nullToString(res[0].mobil),
          formFax: this.nullToString(res[0].fax),
          formHonlap: this.nullToString(res[0].honlap),
          formEmail: this.nullToString(res[0].email),
          formKozterulet: this.nullToString(res[0].kozterulet),
          formKozteruletjelleg: this.nullToString(res[0].kozteruletjelleg),
          formHazszam: this.nullToString(res[0].hazszam),
          formLepcsohaz: this.nullToString(res[0].lepcsohaz),
          formEpulet: this.nullToString(res[0].epulet),
          formEmelet: this.nullToString(res[0].emelet),
          formAjto: this.nullToString(res[0].ajto),
          formPostafiok: this.nullToString(res[0].postafiok),
          cimSwitchActive: !res[0].postafiok,
          formKapcsolattartonev: this.nullToString(res[0].kapcsolattartonev),
          formKapcsolattartotelefon: this.nullToString(res[0].kapcsolattartotelefon),
          formKapcsolattartoemail: this.nullToString(res[0].kapcsolattartoemail),
          formTelepulesNev: this.nullToString(res[0].telepules),
          formIranyitoszamNev: this.nullToString(res[0].irsz),
          formOrszag: {
            keresheto: this.nullToString(res[0].keresheto),
            nev: this.nullToString(res[0].orszag),
            orszagid: this.nullToString(res[0].orszagid),
          },
          formKereses: {
            iranyitoszam: this.nullToString(res[0].irsz),
            irszid: this.nullToString(res[0].irszid),
            nev: this.nullToString(res[0].telepules),
            telepulesid: this.nullToString(res[0].telepulesid),
            telepulesnev: this.nullToString(res[0].telepules + ' (' + res[0].irsz + ')'),
          },
          files: res[0].objectParam,
          formBankszamlaszam: res[0].bankszamlaszam
        }, () => {
          // this.getSpecialis(res[0].specialis);
          this.getAktivSzekhelyList([this.state.formSzekhely]);
        });
      }
    });
  }

  addCegadat = (event, cegadatObj) => {
    const {
      cegadatId,
      modositas,
      formTipus,
      formTeljesnev,
      formSzekhely,
      formRovidnev,
      formCegforma,
      formBejegyzesdatum,
      formCegjegyzekszam,
      formAdoszam,
      formKozossegiadoszam,
      formTelefon,
      formMobil,
      formFax,
      formHonlap,
      formEmail,
      formKozterulet,
      formKozteruletjelleg,
      formHazszam,
      formLepcsohaz,
      formEpulet,
      formEmelet,
      formAjto,
      formPostafiok,
      formKapcsolattartonev,
      formKapcsolattartotelefon,
      formKapcsolattartoemail,
      formKezdete,
      formVege,
      formOrszag,
      formBankszamlaszam,
      // formIranyitoszam,
      // formTelepules,
      formIranyitoszamNev,
      formTelepulesNev,
      formKereses
    } = this.state;
    let submitObj = {};

    this.setState({ submitButtonLoading: true });
  
    if (formOrszag && formOrszag.keresheto) {
      submitObj.telepulesid = this.emptyOrNull(formKereses.telepulesid);
      submitObj.irszid = this.emptyOrNull(formKereses.irszid);
    } else {
      submitObj.telepules = this.emptyOrNull(formTelepulesNev);
      submitObj.irsz = this.emptyOrNull(formIranyitoszamNev);
    }

    if (modositas) submitObj.id = this.emptyOrNull(cegadatId);
    submitObj.tipus = this.emptyOrNull(formTipus);
    submitObj.teljesnev = this.emptyOrNull(formTeljesnev);
    submitObj.szekhelyentity = { id: formTipus !== 'S' ? this.emptyOrNull(formSzekhely) : null };
    submitObj.rovidnev = formTipus === 'S' ? this.emptyOrNull(formRovidnev) : null;
    submitObj.cegforma = formTipus === 'S' ? this.emptyOrNull(formCegforma) : null;
    submitObj.bejegyzesdatum = formTipus === 'S' ? this.emptyOrNull(formBejegyzesdatum) : null;
    submitObj.cegjegyzekszam = formTipus === 'S' ? this.emptyOrNull(formCegjegyzekszam) : null;
    let adoszam = this.emptyOrNull(cegadatObj.formAdoszam);
    submitObj.adoszam = adoszam ? adoszam.replace(/-/g, '') : null;
    submitObj.kozossegiadoszam = this.emptyOrNull(formKozossegiadoszam);
    submitObj.kezdete = formKezdete && TimeFormatter.formatIso(formKezdete);
    submitObj.vege = formVege && TimeFormatter.formatIso(formVege);
    submitObj.telefon = this.emptyOrNull(formTelefon);
    submitObj.mobil = this.emptyOrNull(formMobil);
    submitObj.fax = this.emptyOrNull(formFax);
    submitObj.honlap = this.emptyOrNull(formHonlap);
    submitObj.email = this.emptyOrNull(formEmail);
    submitObj.orszagid = this.emptyOrNull(formOrszag.orszagid);
    submitObj.kozterulet = this.emptyOrNull(formKozterulet);
    submitObj.kozteruletjelleg = this.emptyOrNull(formKozteruletjelleg);
    submitObj.hazszam = this.emptyOrNull(formHazszam);
    submitObj.lepcsohaz = this.emptyOrNull(formLepcsohaz);
    submitObj.epulet = this.emptyOrNull(formEpulet);
    submitObj.emelet = this.emptyOrNull(formEmelet);
    submitObj.ajto = this.emptyOrNull(formAjto);
    submitObj.postafiok = this.emptyOrNull(formPostafiok);
    submitObj.kapcsolattartonev = this.emptyOrNull(formKapcsolattartonev);
    submitObj.kapcsolattartotelefon = this.emptyOrNull(formKapcsolattartotelefon);
    submitObj.kapcsolattartoemail = this.emptyOrNull(formKapcsolattartoemail);
    submitObj.bankszamlaszam = formBankszamlaszam;
    let submitObjParam = JSON.parse(JSON.stringify(this.state.files));
    submitObjParam.forEach((item) => {
      if (item.new) {
        delete item.id;
      }
    });
    submitObj.objectParam = submitObjParam;
    // HRSZ TODO

    if (modositas) {
      Services.modifyCegadat(submitObj, this.state.cegadatValtozas, (err, res) => {
        if (!err) {
          this.setState({ submitButtonLoading: false });
          this.props.globals.addSuccess('Cégadat módosítva!');
          this.onBack();
        } else {
          this.setState({ submitButtonLoading: false });
        }
      });
    } else {
      Services.addCegadat(submitObj, (err, res) => {
        if (!err) {
          this.setState({ submitButtonLoading: false });
          this.props.globals.addSuccess('Cégadat felvéve!');
          this.onBack();
        } else {
          this.setState({ submitButtonLoading: false });
        }
      });
    }
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  emptyToZero = (data) => {
    if (!data || data === '') return 0;
    return data;
  }

  setActiveLogo = (file) => {
    let newFiles = JSON.parse(JSON.stringify(this.state.files));
    newFiles.forEach((item, idx) => {
      if (item.id === file.id) {
        item.logo = true;
      } else {
        item.logo = false;
      }
    });
    this.setState({
      files: newFiles
    });
  }

  onDropObject = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = this.state.files || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          id: Lib.Browser.uuidv4()
        });
        this.setState({ files: files });
      };
      reader.readAsBinaryString(file);
    });
  }

  downloadObject = (file) => {
    if (file.preview) {
      window.open(file.preview, '_blank');
    } else {
      this.getContent(file.id);
    }
  }

  removeObject = (file) => {
    if (file.preid) {
      let files = this.state.files.filter(f => f.preid !== file.preid);
      this.setState({ files: files });
    } else {
      let files = this.state.files.filter(f => f.id !== file.id);
      this.setState({ files: files });
    }
  }

  getContent = (objid) => {
    let obj = this.state.files.find(f => f.id == objid);
    Services.downloadObject(objid, (err, res) => {
      if (!err) {
        fileSaver.saveAs(new Blob([res[0]], { type: obj.mime }), obj.docname);
      }
    });
  }

  formatBytes = (bytes) => {
    if (bytes < 1024) return bytes + ' bájt';
    if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
    if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
    return (bytes / 1073741824).toFixed(3) + ' GB';
  };

  onBack = () => {
    this.props.globals.route.navigate({ 
      pathname: this.props.globals.public_url.concat('/admin/torzsadatok/cegadatok'),
      state: {
        lek: this.state.lek
      }
    })
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleDateTimeInputChange = (e, v, name) => {
    if(this.selected) {
      this.selected = false;
      switch (name) {
        case 'formKezdete':
          this.setState({ formKezdete: (moment(e).startOf('day')) });
          break;
        case 'formVege':
          this.setState({ formVege: (moment(e).endOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (name) {
        case 'formKezdete':
          this.setState({ formKezdete: (v === '' ? null : e) });
          break;
        case 'formVege':
          this.setState({ formVege: (v === '' ? null : e) });
          break;
        default:
          break;
      }
    }
  }

  loadOrszagOptions = (input, callback) => {
    if (input.length !== 0) {
      Services.listOrszag(input, (err, res) => {
        if (!err) {
          callback(res[0]);
        }
      });
    }
  }

  loadKeresesOptions = (input, callback) => {
    if (input.length !== 0) {
      Services.listCim(input, this.state.formOrszag && this.state.formOrszag.orszagid, (err, res) => {
        if (!err) {
          let options = [];
          res[0].forEach((item) => {
            item.telepuirszek.forEach((iranyitoszam) => {
              options.push({
                telepulesnev: item.telepulesnev + ' (' + iranyitoszam.iranyitoszam + ')',
                telepulesid: item.telepulesid,
                iranyitoszam: iranyitoszam.iranyitoszam,
                irszid: iranyitoszam.telepuirszid,
                nev: item.telepulesnev,
                // irsz:
              });
            });
          });
          callback(options);
        }
      });
    }
  }

  loadTelepulesOptions = (input, callback) => {
    if (input.length !== 0) {
      Services.listIranyitoszam(input, (err, res) => {
        if (!err) {
          callback(null, { options: res[0] });
        }
      });
    }
  }

  handleChangeOrszagInput = (value, formChangeFn) => {
    if (value && value !== '') {
      this.setState({
        formOrszag: value,
        formKereses: '',
        formIranyitoszamNev: '',
        formTelepulesNev: ''
      });
    } else {
      this.setState({
        formOrszag: '',
        formKereses: '',
        formIranyitoszamNev: '',
        formTelepulesNev: ''
      });
    }

    formChangeFn('formIranyitoszamNev', '');
    formChangeFn('formTelepulesNev', '');
  }

  handleChangeKeresesInput = (value, formChangeFn) => {
    if (value && value !== '') {
      this.setState({
        formKereses: value,
        formTelepulesNev: value.nev,
        formIranyitoszamNev: value.iranyitoszam
      });

      formChangeFn('formIranyitoszamNev', value.iranyitoszam ? value.iranyitoszam : '');
      formChangeFn('formTelepulesNev', value.nev ? value.nev : '');
    } else {
      this.setState({
        formKereses: '',
        formTelepulesNev: '',
        formIranyitoszamNev: ''
      });

      formChangeFn('formIranyitoszamNev', '');
      formChangeFn('formTelepulesNev', '');
    }
  }

  handleChangeTelepulesInput = (value) => {
    if (value && value !== '') {
      this.setState({
        formTelepules: value,
      });
    } else {
      this.setState({
        formTelepules: '',
      });
    }
  }

  renderFormCardLogic = (change) => {
    const {
      formTipus,
      formTeljesnev,
      formSzekhely,
      formRovidnev,
      formCegforma,
      formAdoszam,
      formKozossegiadoszam,
      formCegjegyzekszam,
      formTelefon,
      formMobil,
      formFax,
      formHonlap,
      formEmail,
      formKozterulet,
      formKozteruletjelleg,
      formHazszam,
      formLepcsohaz,
      formEpulet,
      formEmelet,
      formAjto,
      formPostafiok,
      formKapcsolattartonev,
      formKapcsolattartotelefon,
      formKapcsolattartoemail,
      formKezdete,
      formVege,
      formBejegyzesdatum,
      formOrszag,
      // formIranyitoszam,
      // formTelepules,
      formIranyitoszamNev,
      formTelepulesNev,
      formKereses,
      cimSwitchActive
    } = this.state;

    const titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <h5 style={titleStyle}>Cég adatai:</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              label="Cégadat típus: *"
              type="select"
              name="formTipus"
              required
              value={formTipus}
              disabled={this.state.modositas}
              onChange={this.handleInputChange}
              defaultSelect={<option value="">Válassz típust...</option>}
              selectOptions={this.state.cegadatTipusOptions}
            />
          </div>
          <div className="col-md-8" />
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              label="Cég teljes neve: *"
              name="formTeljesnev"
              value={formTeljesnev}
              onChange={this.handleInputChange}
              maxLength="150"
              required
            />
          </div>
          {(formTipus === 'T' || formTipus === 'F') && (
            <div className="col-md-6">
              <RFField
                label="Hozzárendelt székhely: "
                type="select"
                name="formSzekhely"
                value={formSzekhely}
                onChange={this.handleInputChange}
                required
                defaultSelect={<option value="">Válassz értéket...</option>}
                selectOptions={this.state.cegadatSzekhelyOptions}
              />
            </div>
          )}
          {(formTipus === '' || formTipus === 'S') && (
            <div className="col-md-4">
              <RFField
                label="Rövidített neve: *"
                name="formRovidnev"
                value={formRovidnev}
                onChange={this.handleInputChange}
                maxLength="100"
                required
              />
            </div>
          )}
          {(formTipus === '' || formTipus === 'S') && (
            <div className="col-md-4">
              <RFField
                label="Cégforma: "
                type="select"
                name="formCegforma"
                value={formCegforma}
                onChange={this.handleInputChange}
                defaultSelect={<option value="">Válassz értéket...</option>}
                selectOptions={this.state.cegadatFormaOptions}
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-4">
            <DatetimePicker
              label="Kezdete: *"
              required
              placeholder="éééé-hh-nn"
              onChange={(e, v) => this.handleDateTimeInputChange(e, v, 'formKezdete')}
              onSelect={(e,v) => { this.selected = true }}
              value={formKezdete && new Date(formKezdete)}
              id="formKezdete"
              name="formKezdete"
              disabled={this.state.cegadatValtozas != true}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-4">
            <DatetimePicker
              label="Vége:"
              placeholder="éééé-hh-nn"
              onChange={(e, v) => this.handleDateTimeInputChange(e, v, 'formVege')}
              onSelect={(e,v) => { this.selected = true }}
              value={formVege && new Date(formVege)}
              min={formKezdete && new Date(formKezdete)}
              id="formVege"
              name="formVege"
              timePrecision="seconds"
            />
          </div>
          {(formTipus === '' || formTipus === 'S') && (
            <div className="col-md-4">
              <DatePicker
                label="Bejegyzés dátuma:"
                placeholder="éééé-hh-nn"
                onChange={(e, v) => this.handleDateInputChange(e, v, 'formBejegyzesdatum')}
                value={formBejegyzesdatum && new Date(formBejegyzesdatum)}
                id="formBejegyzesdatum"
                name="formBejegyzesdatum"
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-4">
            <SlaveAvInput
              label="Adószám: *"
              name="formAdoszam"
              value={formAdoszam}
              required
              szuroTipus={NumberFormatter.ADOSZAM}
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Közösségi adószám: "
              name="formKozossegiadoszam"
              value={formKozossegiadoszam}
              onChange={this.handleInputChange}
              maxLength="100"
            />
          </div>
          {(formTipus === '' || formTipus === 'S') && (
            <div className="col-md-4">
              <RFField
                label="Cégjegyzékszám: "
                name="formCegjegyzekszam"
                value={formCegjegyzekszam}
                onChange={this.handleInputChange}
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-12">
            <h5 style={titleStyle}>Elérhetőségek:</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              label="Telefon: *"
              name="formTelefon"
              value={formTelefon}
              onChange={this.handleInputChange}
              maxLength="20"
              required
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Mobiltelefon:"
              name="formMobil"
              value={formMobil}
              onChange={this.handleInputChange}
              maxLength="20"
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Fax:"
              name="formFax"
              value={formFax}
              onChange={this.handleInputChange}
              maxLength="20"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              label="Honlap:"
              name="formHonlap"
              value={formHonlap}
              onChange={this.handleInputChange}
              regex={[
                "(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})",
                "Hibás honlap formátum! (http|https://www.xyz.xyz)"
              ]}
              maxLength="100"
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="E-mail:"
              name="formEmail"
              type="text"
              value={formEmail}
              onChange={this.handleInputChange}
              maxLength="100"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h5 style={titleStyle}>Bank adatok:</h5>
          </div>
        </div>
        <div className="row">
          {this.state.formBankszamlaszam && this.state.formBankszamlaszam.map((item, idx) => {
            return (
              <div className="col-md-4" key={idx.toString()}>
                <BankCard
                  idx={idx.toString()}
                  key={idx.toString()}
                  bankszamlaszam={item.bankszamlaszam}
                  ibanszam={item.ibanszam}
                  penzintezet={item.penzintezet}
                  onModifyClick={() => this.handleBankadatChange(idx)}
                  onDeleteClick={() => this.handleBankadatDelete(idx)}
                />
              </div>
            );
          })}
        </div>
        <div className="row">
          <div className="col-md-12">
            <Button className="pull-left table-new-button" color="success" onClick={() => this.handleNewBankadatClick()}>Új hozzáadása</Button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h5 style={titleStyle}>Cím:</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3" style={{ marginBottom: '1rem' }}>
            <SelectField
              variant='async'
              label='Ország:'
              name="formOrszag"
              id="formOrszag"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              searchPromptText="Kezdj el gépelni a kereséshez..."
              loadingMessage={() => 'Keresés...'}
              onChange={v => this.handleChangeOrszagInput(v, change)}
              clearable
              ignoreAccents={false}
              loadOptions={_.debounce(this.loadOrszagOptions, 1000)}
              isLoading={false}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.orszagid}
              value={formOrszag}
              cache={false}
              autoload={false}
              required
            />
          </div>
          { formOrszag && formOrszag.keresheto && (
            <div className="col-md-3" style={{ marginBottom: '1rem' }}>
              <Label for="formKereses">Keresés: </Label>
              <Select
                styles={{
                  control: base => ({
                    ...base,
                    '&:focus': { borderColor: 'red' }, // border style on hover
                    border: '1px solid lightgray', // default border color
                    boxShadow: 'none', // no box-shadow
                    borderRadius: '0'
                  }),
                }}
                name="formKereses"
                id="formKereses"
                placeholder="Település vagy irányítószám"
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                onChange={v => this.handleChangeKeresesInput(v, change)}
                // isClearable
                ignoreAccents={false}
                // loadOptions={(input, callback) => this.loadKeresesOptions(input, callback)}
                loadOptions={_.debounce(this.loadKeresesOptions, 1000)}
                getOptionLabel={option => option.telepulesnev}
                getOptionValue={option => option.telepulesid}
                isLoading={false}
                value={formKereses}
                cache={false}
                autoload={false}
              />
            </div>
          )}
          <div className="col-md-3">
            <RFField
              label="Irányítószám: *"
              name="formIranyitoszamNev"
              maxLength="20"
              value={formIranyitoszamNev}
              onChange={this.handleInputChange}
              disabled={(formOrszag && formOrszag.keresheto) || (formOrszag === '')}
              required
            />
          </div>
          <div className="col-md-3">
            <RFField
              label="Település: *"
              name="formTelepulesNev"
              value={formTelepulesNev}
              onChange={this.handleInputChange}
              disabled={(formOrszag && formOrszag.keresheto) || (formOrszag === '')}
              required
            />
          </div>
          {/* <div className="col-md-3">
            <Label for="formTelepules">Település: *</Label>
            <Select.Async
              name="formTelepules"
              id="formTelepules"
              placeholder="Kezdj el gépelni..."
              noResultsText="Nincs keresési eredmény"
              searchPromptText="Kezdj el gépelni a kereséshez..."
              loadingPlaceholder="Keresés..."
              onChange={v => this.handleChangeTelepulesInput(v)}
              clearable
              ignoreAccents={false}
              loadOptions={_.debounce((input, callback) => this.loadTelepulesOptions(input, callback), 1000)}
              isLoading={false}
              valueKey="telepulesid"
              labelKey="telepulesnev"
              value={formTelepules}
              cache={false}
              autoload={false}
            />
        </div> */}
        </div>
        <div className="row">
          <div className="col-md-12">
            <SwichButton
              active={cimSwitchActive}
              trueToggle={() => this.toggleCimSwitch(true)}
              falseToggle={() => this.toggleCimSwitch(false)}
              style={{ marginBottom: 15, marginTop: 8 }}
              trueLabel="Cím"
              falseLabel="Postafiók"
            />
          </div>
        </div>
        { cimSwitchActive && (
          <React.Fragment>
            <div className="row">
              <div className="col-md-3">
                <RFField
                  label="Közterület neve: *"
                  name="formKozterulet"
                  value={formKozterulet}
                  onChange={this.handleInputChange}
                  maxLength="50"
                  required
                />
              </div>
              <div className="col-md-3">
                <RFField
                  label="Közterület jellege: *"
                  name="formKozteruletjelleg"
                  value={formKozteruletjelleg}
                  onChange={this.handleInputChange}
                  maxLength="20"
                  required
                />
              </div>
              <div className="col-md-3">
                <RFField
                  label="Házszám: *"
                  name="formHazszam"
                  value={formHazszam}
                  onChange={this.handleInputChange}
                  maxLength="20"
                  required
                />
              </div>
              <div className="col-md-3">
                <RFField
                  label="Épület:"
                  name="formEpulet"
                  value={formEpulet}
                  onChange={this.handleInputChange}
                  maxLength="4"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <RFField
                  label="Lépcsőház: "
                  name="formLepcsohaz"
                  id="formLepcsohaz"
                  value={formLepcsohaz}
                  onChange={this.handleInputChange}
                  maxLength="4"
                />
              </div>
              <div className="col-md-3">
                <RFField
                  label="Emelet:"
                  name="formEmelet"
                  value={formEmelet}
                  onChange={this.handleInputChange}
                  maxLength="10"
                />
              </div>
              <div className="col-md-3">
                <RFField
                  label="Ajtó:"
                  name="formAjto"
                  value={formAjto}
                  onChange={this.handleInputChange}
                  maxLength="15"
                />
              </div>
            </div>
          </React.Fragment>
        )}
        { !cimSwitchActive && (
          <div className="row">
            <div className="col-md-3">
              <RFField
                label="Postafiók: *"
                name="formPostafiok"
                value={formPostafiok}
                onChange={this.handleInputChange}
                required
                maxLength="40"
              />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-12">
            <h5 style={titleStyle}>Kapcsolattartó adatai:</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <RFField
              label="Név:"
              name="formKapcsolattartonev"
              value={formKapcsolattartonev}
              onChange={this.handleInputChange}
              maxLength="150"
            />
          </div>
          <div className="col-md-3">
            <RFField
              label="Telefon:"
              name="formKapcsolattartotelefon"
              value={formKapcsolattartotelefon}
              onChange={this.handleInputChange}
              maxLength="20"
            />
          </div>
          <div className="col-md-3">
            <RFField
              label="E-mail:"
              name="formKapcsolattartoemail"
              value={formKapcsolattartoemail}
              onChange={this.handleInputChange}
              type="text"
              maxLength="100"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h5 style={titleStyle}>Fájl feltöltése:</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DropZone
              multiple
              onDrop={this.onDropObject}
              className="custom-dropzone"
            >
              {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({ className: 'custom-dropzone'})}>
                      <input {...getInputProps()} />
                      <div className="dropzone-text">
                        {'Húzd ide a fájlokat vagy kattints a négyzetbe egy kép feltöltéséhez!'}
                      </div>
                    </div>
                )}
            </DropZone>
          </div>
        </div>
        <div className="row">
          {this.state.files && this.state.files.map((item, idx) => {
            return (
              <div className="col-md-4" key={idx.toString()}>
                <FileCard
                  key={idx.toString()}
                  mime={item.mime}
                  title={item.docname}
                  length={this.formatBytes(item.length)}
                  activeLogo={item.logo}
                  onLogoClick={() => this.setActiveLogo(item)}
                  onDownloadClick={() => this.downloadObject(item)}
                  onDeleteClick={() => this.removeObject(item)}
                />
              </div>
            );
          })}
        </div>
        <div className="row">
          <div className="col-md-12">
            <ProgressButton
              color="primary"
              style={{ cursor: 'pointer' }}
              loading={this.state.submitButtonLoading}
            >
              {'Mentés'}
            </ProgressButton>
            {' '}
            <Button
              color="secondary"
              onClick={this.onBack}
              style={{ cursor: 'pointer' }}
            >
              {'Vissza'}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderFormCard = () => {
    const cardStyle = {
      padding: 20
    };

    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            {this.state.formTitle}
          </div>
          <RFForm onSubmit={this.addCegadat}>
            <FormContext.Consumer>
              {({ change }) => (
                <div style={cardStyle}>
                  {{
                    LOAD: (<div className="col-md-12"><Loader /></div>),
                    NETW: (<NetworkEmptyState
                      hasImage
                      submitClick={() => this.getTipusList()}
                    />),
                    DATA: (this.renderFormCardLogic(change))
                  }[this.state.formCardStatus]}
                </div>
              )}
            </FormContext.Consumer>
          </RFForm>
        </div>
      </div>
    );
  }

  render() {
    const {
      formModalBankszamlaszam,
      formModalPenzintezet,
      formModalIbanszam
    } = this.state;


    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            {this.renderFormCard()}
          </div>
        </div>
        <Modal isOpen={this.state.modalBankadat} toggle={this.toggleBankadat} backdrop="static">
          <RFForm
            modal
            onSubmit={this.addBankadat}
            title={this.state.modalBankadatTitle}
            footer={
              <>
                <ProgressButton color="primary" loading={this.state.bankButtonLoading}>{this.state.modalBankadatButtonText}</ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleBankadat}>Mégsem</Button>
              </>
            }
          >
            <div className="row">
              <div className="col-md-12">
                <RFField
                  label="Számlavezető pénzintézet neve: *"
                  name="formModalPenzintezet"
                  value={formModalPenzintezet}
                  onChange={this.handleInputChange}
                  maxLength="100"
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <SlaveAvInput
                  label="Bankszámlaszám: *"
                  name="formModalBankszamlaszam"
                  value={formModalBankszamlaszam}
                  onChange={this.handleInputChange}
                  szuroTipus={NumberFormatter.BANKSZAMLA}
                  maxLength="26"
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <RFField
                  label="IBAN szám: "
                  name="formModalIbanszam"
                  value={formModalIbanszam}
                  onChange={this.handleInputChange}
                  maxLength="100"
                // required
                />
              </div>
            </div>
          </RFForm>
        </Modal>
      </React.Fragment>
    );
  }
}

CegadatForm.propTypes = {
  globals: PropTypes.object
};

export default CegadatForm;
